import { createElement, type ComponentType } from 'react'
import { createRoot } from 'react-dom/client'

// React islands convention (DESIGN.md §7.1): server-rendered ERB owns the page;
// React mounts only on elements marked <div data-island="Name" data-props="{…}">.
// Register island components here; they are code-split via dynamic import.
/* eslint-disable @typescript-eslint/no-explicit-any */
const registry: Record<string, () => Promise<{ default: ComponentType<any> }>> = {
  CartBadge: () => import('./CartBadge'),
  AddToCart: () => import('./AddToCart'),
  CartPage: () => import('./CartPage'),
  CheckoutPage: () => import('./CheckoutPage'),
  OrderStatus: () => import('./OrderStatus'),
}

export function mountIslands(): void {
  document.querySelectorAll<HTMLElement>('[data-island]').forEach(async (el) => {
    const name = el.dataset.island
    if (!name || !registry[name]) return
    const props = el.dataset.props ? JSON.parse(el.dataset.props) : {}
    const { default: Component } = await registry[name]()
    createRoot(el).render(createElement(Component, props))
  })
}
